import { useTranslation } from "react-i18next";

export default function Servicios()
{
    const { t } = useTranslation();
    return(
        <section className="page-section bg-primary text-white mb-0" id="servicios">
            <div className="container">
            <h2 className="page-section-heading text-center text-uppercase text-white" style={{margin:'20px'}}>{t('services_main_title')}</h2>
                    <div className="row text-center">
                        <div className="col-sm">
                            <img src='assets/img/servicios1.jpg' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios1'/>
                            <h2>{t('services_title1')}</h2>
                            <p>{t('services_text1')}</p>
                        </div>
                        <div className="col-sm">
                            <img src='assets/img/servicios2.jpg' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios2'/>
                            <h2>{t('services_title2')}</h2>
                            <p>{t('services_text2')}</p>
                        </div>
                        <div className="col-sm">
                            <img src='assets/img/servicios3.jpg' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios3'/>
                            <h2>{t('services_title3')}</h2>
                            <p>{t('services_text3')}</p>
                        </div>
                    <div className="row text-center">
                        <div className="col-sm">
                            <img src='assets/img/servicios4.png' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios4'/>
                            <h2>{t('services_title4')}</h2>
                            <p>{t('services_text4')}</p>
                        </div>
                        <div className="col-sm">
                            <img src='assets/img/servicios5.png' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios5'/>
                            <h2>{t('services_title5')}</h2>
                            <p>{t('services_text5')}</p>
                        </div>
                        <div className="col-sm">
                            <img src='assets/img/servicios6.jpg' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios6'/>
                            <h2>{t('services_title6')}</h2>
                            <p>{t('services_text6')}</p>
                        </div>
                    </div>
                    <div className="row text-center">
                        <div className="col-sm" style={{width:'300px'}}>
                            <img src='assets/img/servicios7.jpg' className="rounded" style={{width:'300px',margin:'30px'}} alt='servicios7'/>
                            <h2>{t('services_title7')}</h2>
                            <p>{t('services_text7')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}